import React, { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

export const SmartSearchContext = createContext(null);

export default function SmartSearchContextProvider({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <SmartSearchContext.Provider value={{ isModalOpen, setIsModalOpen }}>
      {children}
    </SmartSearchContext.Provider>
  );
}

SmartSearchContextProvider.propTypes = {
  children: PropTypes.node,
};

export function useSmartSearchContext() {
  const context = useContext(SmartSearchContext);
  if (!context) {
    throw new Error(
      'useSmartSearchContext must be used within a SmartSearchContextProvider'
    );
  }
  return context;
}
